import { render } from "./AccountantDetails.vue?vue&type=template&id=2d9aa5eb"
import script from "./AccountantDetails.vue?vue&type=script&lang=js"
export * from "./AccountantDetails.vue?vue&type=script&lang=js"

import "./AccountantDetails.vue?vue&type=style&index=0&id=2d9aa5eb&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__